// Figma "User Colors", Colors page frame 491 (node 809:39827), in Figma order
export default [
    "#EBC950", // 01 Yellow
    "#56CFC7", // 02 Mint
    "#8DE557", // 03 Green
    "#F2F0E9", // 04 White
    "#EC853B", // 05 Orange
    "#1FAFD4", // 06 Cyan
    "#CA4EE9", // 07 Pink
    "#E73D8F", // 08 Raspberry
    "#EC3B3B", // 09 Red
    "#6B7FEB", // 10 Blue
    "#AA69FF", // 11 Purple
    "#B7C8CC", // 12 Light Gray
]
